
import React from "react";
import {
  Form, SaveButton, DeleteButton
} from "react-admin";
import { Typography, Box, Grid, Toolbar } from '@mui/material';


import { generateInputField } from "../factory";



const UiCustomForm = ({
  resourcesFields,
  resourcesTabs,
  tabs,
  canDelete, // Destructured here so it's not included in `rest`
  formProps,
  id,
  ...rest // Spread the remaining props
}) => (
  <Form
    {...rest} // Pass only the remaining props to the Form component
    render={({ ...props }) => (
      // here starts the custom form layout
      <form>
        <div style={{ padding: 10 }}>

          <Grid container spacing={3} borderRadius={16} borderColor="primary.main">
            {tabs.map((t, index) => {

              return (
                <>
                  <Grid
                    borderRadius={16}
                    borderColor="primary.main"
                    item
                    size={{
                      xs: resourcesTabs[index][0] == null ? 6 : resourcesTabs[index][0]['width_class']
                    }}
                  >
                    <Typography variant="h6" gutterBottom>{t}</Typography>

                    {resourcesFields[index] && resourcesFields[index].map((f, fieldIndex) => {
                      // Create unique key using source_name + fieldIndex
                      const uniqueKey = `input-${fieldIndex}-${f.source_name || fieldIndex}`;
                      return generateInputField(f, uniqueKey, id);
                    })}
                  </Grid>


                </>

              );


            }

            )}

          </Grid>
        </div>
        <Toolbar>
          <Box display="flex" justifyContent="space-between" width="100%">
            <SaveButton {...props}
            //saving={formProps.saving}
            //handleSubmitSithRedirect={formProps.handleSubmitSithRedirect}
            />
            {canDelete && <DeleteButton {...props} />}


            {/* // record={formProps.record} 
            /> */}
          </Box>
        </Toolbar>
      </form>
    )}
  />
);



export default UiCustomForm;